import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';

export default function WelcomeToast() {
	const [show, setShow] = useState(false);
	const location = useLocation();
	const logoSrc = `${import.meta.env.BASE_URL}logo-transparent.png`;

	useEffect(() => {
		const justLoggedIn = location.state?.justLoggedIn || sessionStorage.getItem('justLoggedIn') === 'true';

		if (justLoggedIn) {
			setShow(true);
			sessionStorage.removeItem('justLoggedIn');

			const timer = setTimeout(() => {
				setShow(false);
			}, 4000);

			return () => clearTimeout(timer);
		}
	}, [location.state]);

	if (!show) return null;

	const node = (
		<div className="welcome-toast">
			<div className="welcome-toast-content">
				<div className="welcome-toast-icon">
					<img src={logoSrc} alt="" className="gh-logo gh-logo--toast" />
				</div>
				<div className="welcome-toast-text">
					<div className="fw-semibold">Welcome to HortEra!</div>
					<div className="text-muted small">Let&apos;s grow something beautiful together.</div>
				</div>
			</div>
		</div>
	);

	return createPortal(node, document.body);
}
